import {Document, Page, View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {DeepDiveSection} from './DeepDiveSection/DeepDiveSection';
import {RecommendationsHeader} from './RecommendationsHeader';
import {RecommendationsTable} from './RecommendationsTable';
import {ReportCultureFitSection} from './ReportCultureFitSection';
import {ReportHeader} from './ReportHeader';
import {ReportTopQuestionsSection} from './ReportTopQuestionsSection';
import {sharedStyles} from './styles/shared-styles';
import {ApplicantScreeningReport} from '../../../../../types/ApplicantScreeningReport';
import {PdfCultureTypeOverview} from '../../../recruiting/applicant-pdf-export/components/PdfProfile/PdfCultureTypeOverview/PdfCultureTypeOverview';

interface Props {
  t: TFunction;
  currentLanguage: 'en' | 'de';
  reportData?: ApplicantScreeningReport;
}

export const ScreeningApplicantPDFReport = ({t, currentLanguage, reportData}: Props) => {
  if (!reportData) {
    return null;
  }

  return (
    <Document>
      <Page size={'A4'} style={sharedStyles.page}>
        <View style={{flex: 2}} wrap>
          <ReportHeader applicantName={reportData.firstName} jobPosting={reportData.jobPosting} />
          <PdfCultureTypeOverview cultureData={reportData?.cultureType} t={t} currentLanguage={currentLanguage} />
          <ReportCultureFitSection
            t={t}
            lang={currentLanguage}
            pillarData={reportData?.pillarData}
            cultureFit={reportData?.cultureFit}
            applicantName={reportData.firstName}
          />
          <ReportTopQuestionsSection
            topQuestions={reportData.topQuestions}
            t={t}
            applicantName={reportData.firstName}
            currentLanguage={currentLanguage}
          />
          <View break>
            <RecommendationsHeader
              t={t}
              applicantDetails={`${reportData.firstName}, ${reportData.jobPosting}`}
              description={{
                title: t('screeningModule.report.recommendations.recommendationsPage1.title'),
                description: t('screeningModule.report.recommendations.recommendationsPage1.description', {
                  applicantName: reportData.firstName,
                }),
              }}
            />
            <RecommendationsTable
              tableData={reportData.pillarDataCulturalFitDescriptions}
              t={t}
              currentLanguage={currentLanguage}
            />
          </View>
          <View break>
            <RecommendationsHeader
              t={t}
              applicantDetails={`${reportData.firstName}, ${reportData.jobPosting}`}
              description={{
                title: t('screeningModule.report.recommendations.recommendationsPage2.title'),
                description: t('screeningModule.report.recommendations.recommendationsPage2.description'),
              }}
            />
            <DeepDiveSection suggestions={reportData.pillarDataCulturalFitDescriptions} lang={currentLanguage} t={t} />
          </View>
        </View>
        <Text
          style={sharedStyles.pageNumber}
          render={({pageNumber, totalPages}) => `${pageNumber} / ${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  );
};
